import React from 'react'

import classNames from 'classnames'

import { Box, BoxProps } from 'ui/components/Box'
import { Body } from 'ui/components/Text'

import { EndActionComponent } from './types'

import { InputEndActionTextStyle } from './Input.css'

type InputEndActionTextProps = BoxProps & {}

export const InputEndActionText: EndActionComponent<InputEndActionTextProps> = ({
    children,
    className,
    ...props
}) => {
    return (
        <Box className={classNames(InputEndActionTextStyle, className)} {...props}>
            <Body size="m" weight="bold">
                {children}
            </Body>
        </Box>
    )
}
